import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

import { resolveFirebaseClientConfig } from './firebaseClientConfig';

const firebaseConfig = resolveFirebaseClientConfig();

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
